import { render, staticRenderFns } from "./NotificationListView.vue?vue&type=template&id=39cefee6&scoped=true&"
import script from "./NotificationListView.vue?vue&type=script&lang=js&"
export * from "./NotificationListView.vue?vue&type=script&lang=js&"
import style0 from "./NotificationListView.vue?vue&type=style&index=0&id=39cefee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cefee6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VChip,
  VIcon,
})
